export const notes = {
    list: {
        empty: "No notes yet",
        newNote: "New note",
    },
    create: {
        templates: {
            newChatNote: "New Chat Note ({count})",
            childChatNote: "Child Chat Note ({count})",
            newTaskNote: "New Task Note ({count})",
            childTaskNote: "Child Task Note ({count})",
            newMyNote: "New My Note ({count})",
            childMyNote: "Child My Note ({count})",
            newTeamNote: "New Team Note ({count})",
            childTeamNote: "Child Team Note ({count})",
        },
    },
    labels: {
        backToNotesList: "Back to notes list",
        close: "Close",
        teamNotes: "Team Notes",
        source: "Source",
    },
    editor: {
        deleteTooltip: "Delete",
        colorsTooltip: "Colors",
        resetTypeTooltip: "Reset Type",
        downloadTooltip: "Download",
        titlePlaceholder: "Note Title",
        savedChip: "Saved",
    },
    confirm: {
        deleteTitle: "Delete this note?",
        deleteBody: "This action cannot be undone.",
    },
    folders: {
        newFolder: "New folder",
        newSubfolder: "New subfolder",
        newNoteHere: "New note here",
        rename: "Rename",
        moveToFolder: "Move to folder…",
        moveFolder: "Move folder…",
        deleteFolder: "Delete folder",
        deleteFolderTitle: "Delete this folder?",
        deleteFolderWarning:
            "All notes and subfolders inside will be permanently deleted. This cannot be undone.",
        folderNamePlaceholder: "Folder name",
        createTitle: "New folder",
        renameTitle: "Rename folder",
        moveTitle: "Move to folder",
        rootLabel: "My Notes (top level)",
        create: "Create",
        save: "Save",
        move: "Move",
        cancel: "Cancel",
        delete: "Delete",
        emptyFolder: "Empty folder",
        moveNoteHint:
            "Moving a nested note detaches it from its parent note; its own sub-notes move with it.",
    },
    sidebar: {
        unread: "Unread ({count})",
        favorites: "Favorites",
        favoriteFolders: "Folders",
        recents: "Recents",
        workspaces: "Workspaces",
        myNotes: "My Notes",
        taskNotes: "Task Notes",
        chatNotes: "Chat Notes",
        sharedNotes: "Shared Notes",
        teamNotes: "Team Notes",
        noFavorites: "No favorites yet. Star notes to add them here.",
        noRecents: "No recent notes yet.",
        soonBadge: "Soon",
        footerTagline: "Organize your thoughts",
        milestoneLabel: "Milestone",
        addSubNote: "Add sub-note",
        unknownOwner: "Unknown",
    },
    teamNotes: {
        newFolder: "New team folder",
        emptySpace: "No team folders yet. Create one to share notes with everyone.",
        // Visibility
        public: "Anyone on the team can view and edit",
        private: "Only invited people can open this",
        publicInherited: "Open to the team, inherited from the parent folder",
        privateInherited: "Restricted, inherited from the parent folder",
        visibilityLabel: "Who can access this folder",
        visibilityPublic: "Everyone on the team",
        visibilityPublicHint: "Any teammate can read this folder and write in it.",
        visibilityPrivate: "Only people I invite",
        visibilityPrivateHint: "Invite individuals or a whole group.",
        visibilityInherit: "Same as the parent folder",
        visibilityInheritHint: "Everyone who can open the parent can open this too.",
        // Third way to answer "who can access this", offered only when the
        // team is connected to another one. It is a visibility choice from
        // the user's side even though it resolves to "private" plus a share
        // — reaching it by deducing that "only people I invite" is the
        // restriction sharing requires is not something to ask of anyone.
        visibilityExternal: "Share with another organization",
        visibilityExternalHint:
            "Pick connected teams. Each team approves once, then their owner or editor chooses which of their members join. Shared folders are always restricted.",
        // Folders another team shared with yours. Short label, because it
        // shares a narrow sidebar row with the folder's name.
        sharedBadge: "Shared",
        sharedByTeamHint: "{team} shared this folder with your team",
        sharedByAnotherTeamHint: "Another team shared this folder with yours",
        // Members
        manageAccess: "Manage access…",
        viewAccess: "View access…",
        membersTitle: 'Access to "{name}"',
        addPeople: "Add people",
        addGroup: "Add a whole group",
        groupsHint:
            "Invite everyone in a mention group, project, or group chat at once. " +
            "Members are added as they are right now.",
        sourceProject: "Project",
        sourceGm: "Group chat",
        memberCountApprox: "Everyone in the selected groups",
        invitedViaGroup: "via {group}",
        resyncGroup: "Re-sync group",
        resyncHint: "Add anyone who joined {group} since the invite.",
        noMembers: "No one has been invited yet.",
        removeAccess: "Remove access",
        lastOwner: "A folder must keep at least one owner.",
        // Delete
        deleteBlockedTitle: "This folder isn't empty",
        deleteBlockedBody:
            "It still holds {noteCount} note(s) and {folderCount} folder(s) owned by other people. " +
            "Ask them to move or delete their content first.",
        ownerLabel: "Created by {name}",
        memberCount: "{count} with access",
        // Tags
        editTags: "Tags…",
        tagsTitle: 'Tags for "{name}"',
        tagsHint:
            "Click a tag to apply it to this folder. Renaming, recolouring or deleting a tag " +
            "affects every folder that uses it.",
        noTags: "No tags yet. Create one below to start organizing folders.",
        newTagPlaceholder: "New tag name",
        newTagPreview: "Preview",
        tagUsage: "used by {count} folder(s)",
        tagEditFailed: "Couldn't update that tag. It may already exist, or not be yours to edit.",
        tagDeleteFailed: "Couldn't delete that tag. Only its creator or the team owner can.",
    },
    chatTypes: {
        dm: "DM",
        gm: "GM",
        pm: "PM",
        mdm: "MDM",
        chat: "Chat",
    },
    noteTypeLabels: {
        personal: "Personal",
        task: "Task",
        chat: "Chat",
        note: "Note",
    },
    defaults: {
        untitled: "Untitled",
        projectFallback: "Project {projectId}",
        milestoneFallback: "Milestone {milestoneId}",
        taskFallback: "Task #{taskId}",
        someone: "Someone",
    },
    placeholder: {
        selectFromSidebar: "Select from sidebar",
        noNoteSelectedTitle: "No Note Selected",
        chooseMyNoteOrCreate: "Choose a note from the sidebar, or create a new one",
        chooseNoteToEdit: "Choose a note from the sidebar to start editing",
        newMyNote: "New My Note",
        sharedNotesTitle: "Choose a shared note from the sidebar",
    },
    header: {
        myNotesLabel: "My Notes",
        taskNotesLabel: "Task Notes",
        chatNotesLabel: "Chat Notes",
        // Breadcrumb container crumb for a chat note attached to a thread.
        threadCrumb: "Thread",
        // Accessible name for the control that reveals the breadcrumbs
        // folded away on a deeply nested note. The visible label is the
        // count itself, which needs no translation.
        showHiddenCrumbs: "Show {count} hidden breadcrumbs",
        newNote: "New Note",
        share: "Share",
        shareNoteAria: "Share note",
        close: "Close",
        openRelatedChat: "Open related chat",
        copyNoteLink: "Copy note link",
        childNote: "Child Note",
        openInNotes: "Open in Notes",
        deleteNote: "Delete Note",
        shareEllipsis: "Share…",
        importMarkdown: "Import Markdown…",
        exportMarkdown: "Export as Markdown",
        openTask: "Open Task",
        taskIdLabel: "{id}",
        openTaskTooltip: "Open Task {id}",
        openTaskTooltipWithTitle: "Open Task {id} — {title}",
        openTaskAria: "Open Task {id}",
        openTaskAriaWithTitle: "Open Task {id}: {title}",
        ownerLabel: "Owner: {name}",
        ownerLabelWithMore: "Owner: {name} · {count} more",
        membersLabel: "Members",
        ownerProjectTooltip: "Owner project",
    },
    importMd: {
        heading: "Import Markdown",
        importNote: "Import note",
        chooseFile: "Choose a .md file…",
        titleLabel: "Note title",
        folderLabel: "Folder",
        rootFolder: "My Notes (root)",
        importButton: "Import",
        readError: "Couldn't read that file.",
        importError: "Import failed — the note wasn't created.",
        // Batch import of a whole exported folder tree (built for Notion
        // exports, which is why the copy mentions them by name — that is
        // the thing in the user's other tab while they read this).
        modeFile: "One file",
        modeFolder: "Whole folder",
        chooseFolder: "Choose a folder…",
        folderHint:
            "Every subfolder becomes a note folder and every markdown file becomes a note inside it. Notion's page ids are stripped from the names, and images are brought over with the pages.",
        planEmpty: "That folder has no markdown files in it.",
        planSummary: "{folders} folders, {notes} notes",
        previewHeading: "What will be created",
        previewMore: "…and {count} more",
        importFolderButton: "Import folder",
        importingLabel: "Imported {done} of {total}",
        stopButton: "Stop",
        resultNotes: "Created {notes} notes in {folders} folders.",
        resultImages: "Brought over {count} images.",
        resultImagesFailed: "{count} images couldn't be brought over.",
        resultFailures: "{count} pages failed and were skipped.",
        resultCancelled: "Stopped early. Everything created up to that point was kept.",
        resultDone: "Done",
        // Importing a markdown/text ATTACHMENT (chat message or task) — the
        // destination can be any kind of note, not just where it was opened.
        importAsNote: "Import as note",
        fileActionsAria: "File actions for {name}",
        readingFile: "Reading {name}…",
        kindLabel: "Import into",
        kindMy: "My Notes",
        kindTeam: "Team Notes",
        kindTask: "Task note",
        kindChat: "Chat note",
        teamFolderLabel: "Team folder",
        taskLabel: "Task",
        chatLabel: "Chat",
        loadingDestinations: "Loading…",
        noDestinations: "Nothing to import into here.",
        importedTo: "Imported as a note in {where}.",
    },
    // Batch export of a folder tree — the mirror of importMd's folder
    // half, and deliberately laid out so its zip can be imported back.
    exportZip: {
        menuItem: "Export folder as .zip",
        heading: "Export folder",
        summary: "{folders} subfolders, {notes} notes",
        empty: "That folder has no notes in it.",
        hint: "Every note becomes a markdown file inside a folder tree matching this one, with its images alongside it.",
        exportButton: "Export",
        progress: "Exported {done} of {total}",
        stop: "Stop",
        resultNotes: "Exported {count} notes.",
        resultImages: "Included {count} images.",
        resultImagesFailed:
            "{count} images couldn't be downloaded — those links still point at Genos.",
        resultFailures: "{count} notes couldn't be read and were skipped.",
        resultCancelled: "Stopped early. The zip holds everything gathered up to that point.",
        done: "Done",
    },
    autocomplete: {
        searchAria: "Search",
        searchChildNotes: "Search Child Notes",
        searchTaskNotes: "Search Task Notes",
    },
    deleteModal: {
        title: "Delete Note?",
        warning: "This action cannot be undone",
        cancel: "Cancel",
        confirm: "Delete Note",
        childExistsError: "Can't delete because child note(s) exists.",
    },
    sharing: {
        title: 'Share "{title}"',
        ownerDescription:
            "Add teammates by name and choose their role. Editors can change the note; viewers can only read it.",
        viewerDescription:
            "You can see who has access but only the owner can add or remove members.",
        noAccessYet: "No one has explicit access yet.",
        addTeammate: "Add teammate",
        searchPlaceholder: "Search by name or email",
        noMatchingTeammates: "No matching teammates.",
        noMoreToAdd: "No more teammates to add.",
        invite: "Invite",
        done: "Done",
        you: "you",
        removeAccess: "Remove access",
        roles: {
            owner: "Owner",
            editor: "Editor",
            viewer: "Viewer",
        },
    },
    history: {
        chipTooltip: "View version history",
        viewVersions: "View versions",
        chipSummary: "Edited by {name} · {time}",
        title: "Version history",
        ownerDescription:
            "Pick a version to preview it. Restore writes a new version so the history is preserved.",
        viewerDescription:
            "Read-only view — only the note's owner or editors can restore a past version.",
        emptyList: "No history yet. Versions will appear here after the next save.",
        currentChip: "current",
        restoredFrom: "restored from v{version}",
        selectVersionPrompt: "Select a version on the left to preview it.",
        snapshotFrom: "Snapshot from {time}",
        emptyBody: "(empty body)",
        currentVersionFooter: "This is the current version.",
        restoreCanFooter: "Restoring writes a new version on top of the live note.",
        restoreCannotFooter: "You don't have permission to restore.",
        closeButton: "Close",
        restoreButton: "Restore this version",
        unknownEditor: "Unknown",
        relTime: {
            justNow: "just now",
            oneMinute: "1 minute ago",
            minutes: "{n} minutes ago",
            hours: "{n} hours ago",
            days: "{n} days ago",
            oneMinShort: "1m ago",
            minutesShort: "{n}m ago",
            hoursShort: "{n}h ago",
            daysShort: "{n}d ago",
        },
    },
    errors: {
        unauthorizedToken: "Unauthorized. Auth toke is not found.",
        messageIdExists: "Message Id already exists.",
        unauthorizedLoginAgain: "Unauthorized. Please log in again.",
    },

    // "Request access" panel — shown in place of the editor when a
    // shared note URL answers 403 (the note exists; the viewer has no
    // role on it). Mirrors the private-project / private-GM join flows.
    accessRequest: {
        privateBadge: "Private Note",
        heading: "You don't have access to this note",
        body: "Ask the note owner to share it with you. They'll get the request in their inbox and can approve it with one click.",
        sendButton: "Request Access",
        sentTitle: "Request sent",
        sentBody: "You'll be notified when the owner approves your request.",
        sendFailed: "Failed to send the request. Please try again.",
        socketNotFound: "Socket not found.",
    },
} as const;
